<template>
  <span>
    <IconScan2D
      v-if="isEnabledBarcodeReadWithKeyenceHT && hasBCR"
      @click="startScanWithKeyenceHT(handleScanSuccess)"
      class="align-middle mt-2"
      width="28"
      height="28"
      viewBox="0 0 36 36"
    />
    <IconBarcodeReader v-else-if="hasBCR" @click="openBCR" class="align-middle mt-2" />
    <IconOCR
      v-if="isEnabledBarcodeReadWithKeyenceHT && hasOCR"
      @click="startOCRWithKeyenceHT"
      class="align-middle mt-2 mr-2"
      width="28"
      height="28"
      viewBox="0 0 36 36"
    />
    <IconOCR v-else-if="hasOCR" @click="openOCR" class="align-middle mt-2" />
  </span>
  <ActionDialog
    v-model:isShowActionDialog="isShowDialog"
    :label="$t(ocrAction)"
    @update:confirm="confirmText($event)"
    :customBarcodeReaderType="scannerType"
    :ocrReaderType="ocrType"
    :actionType="ocrAction"
    :fieldName="fieldName"
    :initialValue="_modelValue"
    :isShowMultipleScan="isShowMultipleScan"
  />
</template>
<script lang="ts">
import OCRComponent from '@/components/OCRComponent.vue'
import ScanComponent from '@/components/ScanComponent.vue'
import IconBarcodeReader from '@/components/svg/IconBarcodeReader.vue'
import IconOCR from '@/components/svg/IconOCR.vue'
import isEmpty from 'lodash/isEmpty'
import { mixins, Options } from 'vue-class-component'
import { Prop, PropSync } from 'vue-property-decorator'
import ActionDialog from './common/ActionDialog.vue'
import {
  isKeyenceEnterpriseBrowser,
  KeyenceModule,
  ConfigId,
  ocrEnabledCodeTypeSetting,
  ScanResult,
} from '@/utils/keyenceHT/keyenceModules'
import IconScan2D from '@/components/svg/IconScan2D.vue'
import { openMessage } from '@/utils/helpers'
import { EBCRType, ECameraReaderType, EOCRType } from '@/utils/enums'
import KeyenceHTScannerMixin from '@/components/mixins/KeyenceHTScannerMixin.vue'
@Options({
  inheritAttrs: false,
  emits: ['update:modelValue', 'update:result'],
  components: {
    IconOCR,
    IconScan2D,
    IconBarcodeReader,
    OCRComponent,
    ScanComponent,
    ActionDialog,
  },
  name: 'InputReadersSuffix',
})
export default class InputReadersSuffix extends mixins(KeyenceHTScannerMixin) {
  @PropSync('modelValue', { type: [String, Number] }) _modelValue?: string | number
  @Prop({ type: String }) readonly fieldName!: string
  @Prop({ type: String }) readonly ocrType!: string
  @Prop({ type: String }) readonly bcrType!: string
  @Prop({ type: Boolean }) readonly isShowMultipleScan?: boolean

  isShowDialog = false
  ocrAction = ECameraReaderType.OCR

  get hasOCR(): boolean {
    return !isEmpty(this.ocrType) && this.ocrType !== EOCRType.UNKNOWN
  }

  get hasBCR(): boolean {
    return !isEmpty(this.bcrType) && this.bcrType !== EBCRType.UNKNOWN
  }

  get isOCRComponent(): boolean {
    return this.ocrAction === ECameraReaderType.OCR
  }

  get scannerType(): EBCRType {
    return this.bcrType as EBCRType
  }

  openBCR() {
    this.openCameraDialog(ECameraReaderType.BCR)
  }

  openOCR() {
    this.openCameraDialog(ECameraReaderType.OCR)
  }

  confirmText(value: string) {
    this.isShowDialog = false
    this._modelValue = value
    this.$emit('update:result', value)
  }

  handleScanSuccess(detectedText: string) {
    this.confirmText(detectedText)
  }

  openCameraDialog(action: ECameraReaderType) {
    this.isShowDialog = true
    this.ocrAction = action
  }

  onDialogClosing() {
    if (this.$refs?.ocrComponent) this.$refs.ocrComponent.vidOff()
  }

  get isEnabledBarcodeReadWithKeyenceHT() {
    return isKeyenceEnterpriseBrowser() && this.hasBCR && KeyenceModule && KeyenceModule.Scanner
  }

  async startOCRWithKeyenceHT() {
    KeyenceModule.Scanner.setConfig(ConfigId.CodeType, ocrEnabledCodeTypeSetting)

    KeyenceModule.Scanner.clearReadCallback()
    KeyenceModule.Scanner.setReadCallback('keyenceHandyTerminalScanResultCallback')
    window.keyenceHandyTerminalScanResultCallback = (result: ScanResult) => {
      if (result.mDecodeResult !== 'SUCCESS') {
        return
      }
      const resultString =
        typeof result.mStringData === 'string' ? result.mStringData : result.mStringData[0].toString()
      const detectedText = resultString?.trim() || ''
      this.confirmText(detectedText)
    }

    openMessage(this.$t('keyenceModule.messages.scanTextByOCR'), 'info', 4000)

    KeyenceModule.Scanner.startRead()
  }

  async unmounted() {
    this.unmountedKeyenceHTScanner()
  }
}
</script>
